import { render, staticRenderFns } from "./IdeaHeader.vue?vue&type=template&id=3d59104e&"
import script from "./IdeaHeader.vue?vue&type=script&lang=js&"
export * from "./IdeaHeader.vue?vue&type=script&lang=js&"
import style0 from "./IdeaHeader.vue?vue&type=style&index=0&id=3d59104e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports